import { DOMRectangle, LotPosition, NeighboorhoodCoords } from "../types";
import { ImageWidth, Scalers, Settings, Status } from "../constant";
import { isMobile, isTablet } from "mobile-device-detect";

const calculateUnderlayArrowPosition = (elementPosition: DOMRect, svgZoom: number) => {
  let arrowPosition = elementPosition.left + (elementPosition.width - elementPosition.width/svgZoom);
  if(arrowPosition > elementPosition.right){
    arrowPosition = elementPosition.right - (elementPosition.width - elementPosition.width/svgZoom);
  }
  return arrowPosition;
}

export const calculateUnderlayMobileLotPosition = (lotPosition: LotPosition, elementPosition: DOMRect , svgZoom: number) => {
  lotPosition.left = (window.screen.width-336)/2;
    const lotAboveheight = elementPosition.top + elementPosition.width;
    if(lotAboveheight <= 450 ){
      lotPosition.top = elementPosition.bottom - (elementPosition.width - elementPosition.width/svgZoom);
      lotPosition['positionModal'] = 'below';
      lotPosition.arrowPosition = calculateUnderlayArrowPosition(elementPosition, svgZoom);
    } else {
      lotPosition.top = elementPosition.top - 360;
      lotPosition['positionModal'] = 'above';
      lotPosition.arrowPosition = calculateUnderlayArrowPosition(elementPosition, svgZoom);
    }
}
export const getPlatMapModalPosition = (domRect: DOMRectangle, height: number, zoomLevel: number) => {
  const header = document.getElementById("header") as HTMLElement;
  const footer = document.getElementById("footer") as HTMLElement;
  const minTopValue = getMinTopValue(header);
  const maxHeight = window.innerHeight - ((footer ? footer.clientHeight : 0) + 11);
  const modalHeight = height || 126;
  const offSet = getOffsetPosition(domRect, modalHeight, minTopValue, maxHeight, zoomLevel);
  return {
    left: zoomLevel >=19 && offSet.xPosition === "right"? offSet.left+20 : offSet.left,
    top: offSet.top,
    right: domRect.right,
    bottom: domRect.bottom,
    width: domRect.width,
    height: domRect.height,
    x: domRect.x,
    y: domRect.y,
    xPosition: offSet.xPosition,
    yPosition: offSet.yPosition,
    arrowPosition: offSet.arrowPosition,
  };
};

const getOffsetPosition = (domRect, modalHeight, minTopValue, maxHeight, zoomLevel) => {
  const modalWidth = 364;
  const arrow = 17;
  const xYPosition = calculateXYPosition(domRect, modalWidth, arrow, modalHeight, zoomLevel);
  const xPosition = xYPosition.xPosition;
  const yPosition = xYPosition.yPosition;
  let intPopupOffsetTop = xYPosition.intPopupOffsetTop;
  const intPopupOffsetLeft = xYPosition.intPopupOffsetLeft;
  if (intPopupOffsetTop < minTopValue) intPopupOffsetTop = minTopValue;
  else if (intPopupOffsetTop + modalHeight > maxHeight) {
    const diff = intPopupOffsetTop + modalHeight - maxHeight;
    intPopupOffsetTop -= diff;
  }
  let arrowPosition = domRect.top - intPopupOffsetTop - arrow / 2;
  intPopupOffsetTop = arrowPosition < 0 ? intPopupOffsetTop + arrowPosition : intPopupOffsetTop;
  if (intPopupOffsetTop < minTopValue) {
    const diff = minTopValue - intPopupOffsetTop;
    intPopupOffsetTop = minTopValue;
    arrowPosition -= diff;
  }
  return {
    left: intPopupOffsetLeft,
    top: intPopupOffsetTop,
    xPosition,
    yPosition,
    arrowPosition: arrowPosition < 0 ? 2 : arrowPosition,
  };
}

const calculateXYPosition = (domRect, modalWidth, arrow, modalHeight, zoomLevel) => {
  let xPosition = "left",
    yPosition = "top";
  let intPopupOffsetTop = document.body.scrollTop + domRect.top;
  let intPopupOffsetLeft = document.body.scrollLeft + domRect.left + domRect.width / 2;
  if (domRect.left > window.innerWidth / 2) {
    xPosition = "right";
    intPopupOffsetLeft -= modalWidth + arrow;
  }
  else {
    if(zoomLevel<18)
      intPopupOffsetLeft += (arrow-20);
    else  
    intPopupOffsetLeft += arrow
  }
  if (domRect.top > window.innerHeight / 2) {
    yPosition = "bottom";
    intPopupOffsetTop += domRect.height;
    intPopupOffsetTop -= modalHeight - arrow / 2;
  }
  return {
    xPosition,
    yPosition,
    intPopupOffsetLeft,
    intPopupOffsetTop
  };
}

const getMinTopValue = (header) => {
  return (header ? header.clientHeight : 0) + 16;
}

export const getPlatMapModalPositionMobile = (domRect: DOMRectangle) => {
  const intDistanceScrolledLeft = document.body.scrollLeft;
  const intViewportWidth = window.innerWidth;
  const header = document.getElementById("header") as HTMLElement;
  const platmapContainer = document.getElementById("platmap") as HTMLElement;
  const svgElement = platmapContainer.getElementsByTagName("svg")[0] as SVGSVGElement;
  const svgContainer = svgElement.parentNode as HTMLElement;
  const minTopValue = (header ? header.clientHeight : 70) + 16;
  const svgtop = parseFloat(svgContainer.style.top.replace('px', ""));
  const svgOffsetTop = svgtop - domRect.top + minTopValue;
  svgContainer.style.top = `${svgOffsetTop}px`;
  const modalWidth = 364;
  const arrowHeight = 17;
  const modalOffset = (intViewportWidth - modalWidth) / 2;
  const xPosition = "left";
  const yPosition = "top";
  const intPopupOffsetLeft = intDistanceScrolledLeft + domRect.left;
  // if (domRect.left > intViewportWidth / 2) {
  //   xPosition = "right";
  //   intPopupOffsetLeft = intPopupOffsetLeft + domRect.width - modalWidth;
  // }
  const intPopupOffsetTop = minTopValue + arrowHeight + domRect.height / 1.5;
  const arrowPosition = domRect.left - intPopupOffsetLeft;
  return {
    left: isTablet ? intPopupOffsetLeft : domRect.left + arrowHeight,
    top: domRect.top,
    right: domRect.right,
    bottom: domRect.bottom,
    width: domRect.width,
    height: domRect.height,
    x: domRect.x,
    y: domRect.y,
    xPosition,
    yPosition,
    arrowPosition,
  };
};

export const fitSVGToContainer = (div: HTMLElement) => {
  const padding = 20;
  let svgWidth = 0;
  let svgHeight = 0;
  const newSVG = div.querySelectorAll("svg")[0];
  const aspect = newSVG.viewBox.animVal.width / newSVG.viewBox.animVal.height;
  const container = document.getElementById("plan-overlay") as HTMLElement;

  div.style.transform = 'scale(1,1)';
  const ifpWidth = container.clientWidth,
    ifpHeight = container.clientHeight;

  const boundingWidth = ifpWidth - padding,
    boundingHeight = ifpHeight - padding;
  if (aspect > 1) {
    svgHeight = Math.round(boundingWidth / aspect);
    if (svgHeight > boundingHeight) {
      svgHeight = boundingHeight;
      svgWidth = Math.round(boundingHeight * aspect);
    } else {
      svgWidth = boundingWidth;
    }
  } else {
    svgWidth = Math.round(boundingHeight * aspect);
    if (svgWidth > boundingWidth) {
      svgWidth = boundingWidth;
      svgHeight = Math.round(boundingWidth / aspect);
    } else {
      svgHeight = boundingHeight;
    }
  }
  newSVG.setAttribute("width", svgWidth + "px");
  newSVG.setAttribute("height", svgHeight + "px");
  newSVG.setAttribute("preserveaspectratio", "xMidYMid meet");
  div.style.width = `${svgWidth}px`;
  div.style.height = `${svgHeight}px`;
  div.style.margin = "0 auto";

  let translationX = ifpWidth / 2 - div.clientWidth / 2 - 35;
  if (isMobile) {
    if (translationX > 0 || translationX < 0) {
      translationX = 10;
    }
  } else {
    if (translationX > 0) {
      translationX = 0;
    }
  }
  const translationY = ifpHeight / 2 - div.clientHeight / 2;
  div.style.left = `${translationX}px`;
  div.style.top = `${translationY}px`;
  div.style.transformOrigin = "center center";
};

export const getCentroid = (isFitCall) => {
  let availableLots = document.querySelectorAll(`*[data-status^="${Status.AVAILABLE}"]`);
  if (isFitCall) {
    availableLots = document.querySelectorAll(`*[data-status]`);
  }
  const positions: any = [];
  const rectangle: any = {};
  let minX = 0, minY = 0, maxX = 0, maxY = 0;
  availableLots.forEach((element: any) => {
    const positionObject = element.getBoundingClientRect();
    if (minX == 0) {
      minX = maxX = positionObject.x;
      minY = maxY = positionObject.y;
    }
    minX = positionObject.x < minX ? positionObject.x : minX;
    minY = positionObject.y < minY ? positionObject.y : minY;
    maxX = positionObject.x > maxX ? positionObject.x : maxX;
    maxY = positionObject.y > maxY ? positionObject.y : maxY;

    positions.push({ x: positionObject.x, y: positionObject.y });
  });
  rectangle.p1 = { x: minX, y: minY };
  rectangle.p2 = { x: minX, y: maxY };
  rectangle.p3 = { x: maxX, y: minY };
  rectangle.p4 = { x: maxX, y: maxY };
  rectangle.xDist = maxX - minX;
  rectangle.yDist = maxY - minY;
  rectangle.screenWidth = window.innerWidth;
  rectangle.screenHeight = window.innerHeight;
  rectangle.scaleX = rectangle.screenWidth / rectangle.xDist;
  rectangle.scaleY = rectangle.screenHeight / rectangle.yDist;
  //return calculateCenterPosition(positions);
  return rectangle;
};

export const calculateCenterPosition = (positions: any) => {
  let x = 0, y = 0;
  for (let i = 0; i < positions.length; i++) {
    x = x + positions[i].x;
    y = y + positions[i].y;
  }
  return { x: x / positions.length, y: y / positions.length };
};

const isRoman = (string) => {
  // regex pattern
  const pattern = /^(M{1,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})|M{0,4}(CM|C?D|D?C{1,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})|M{0,4}(CM|CD|D?C{0,3})(XC|X?L|L?X{1,3})(IX|IV|V?I{0,3})|M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|I?V|V?I{1,3}))$/
  return pattern.test(string);
};

export const convertToTitleCase = (data: string) => {
  let location = data.replace(/_/g, ' ').replace(/\w+/g, (word) => word[0].toUpperCase() + word.slice(1).toLowerCase());
  const words = location.split(" ");
  words.forEach((word, idx) => {
    if (isRoman(word.toUpperCase())) {
      words[idx] = word.toUpperCase();
    }
  });
  location = words.join(" ");
  return location;
}

export const getTouchesCenter = (touch1, touch2) => {
  return {
    x: (touch1.clientX + touch2.clientX) / 2,
    y: (touch1.clientY + touch2.clientY) / 2,
  };
}
export const getZoomDistance = (e, t) => {
  return Math.sqrt(
    Math.pow(e.clientY - t.clientY, 2) + Math.pow(e.clientX - t.clientX, 2)
  );
}

export const calcZoom = (e, t, n) => {
  return Math.min(t, Math.max(e, n));
}

export const compareSortingValue = (first: string | number, second: string | number) => {
  return first < second ? -1 : first > second ? 1 : 0;
}

export const formatPrice = (value: number)=>{
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  });
  return formatter.format(value);
}

export const dateDiffInDays=(a:Date, b:Date)=>{
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

export const getZoomLevel = (coords: NeighboorhoodCoords[], mapHeight: number, mapWidth: number) => {
  const coordinates = [] as any;
  coords.forEach((coord) => {
    coordinates.push([coord.latitude, coord.longitude]);
  });
  const WORLD_DIM = { height: 256, width: 256 };
  const ZOOM_MIN = 17;
  const maxZoom = Settings.MAP_MAX_SVG_SCALE;
  function latRad(lat: number): number {
    const sin = Math.sin((lat * Math.PI) / 180);
    const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
    return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
  }
  function zoom(mapPx: number, worldPx: number, fraction: number): number {
    return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
  }
  const bounds = coordinates.reduce(
    (bbox, coord) => {
      const [lat, lng] = coord;
      bbox[0][0] = Math.min(bbox[0][0], lat);
      bbox[0][1] = Math.min(bbox[0][1], lng);
      bbox[1][0] = Math.max(bbox[1][0], lat);
      bbox[1][1] = Math.max(bbox[1][1], lng);
      return bbox;
    },
    [
      [90, 180],
      [-90, -180],
    ] as [number, number][]
  );
  const latFraction = (latRad(bounds[1][0]) - latRad(bounds[0][0])) / Math.PI;
  let min = Math.min(mapHeight, mapWidth);
  if (mapHeight === 0 || mapWidth === 0) {
    min = Math.max(mapHeight, mapWidth);
  }
  const zooml = zoom(min ?? 400, WORLD_DIM.height, latFraction);
  return Math.min(zooml - 1, ZOOM_MIN);
};

export const getCentrePoint = (coords: NeighboorhoodCoords[]) => {
  let latSum = 0;
  let longSum = 0;
  coords.forEach((pin) => {
    latSum += Number(pin.latitude);
    longSum += Number(pin.longitude);
  });
  const avgLat = Number(latSum / coords.length);
  const avgLong = Number(longSum / coords.length);
  return {
    latitude: avgLat,
    longitude: avgLong,
  };
}

export const addImageScaler = (url: string, scale = Scalers.SMALL, width = ImageWidth.SMALL) => {
  if (url) {
    const imgUrl = new URL(url);
    const params = new URLSearchParams(imgUrl.search);
    if (!params.has("scale")) {
      params.set('scale', scale);
      params.set('io', `transform:fill,width:${width}`);
      imgUrl.search = params.toString();
    }
    return imgUrl.toString();
  }
  return url;
}